<template>
  <ValidationField
    :uuid="uuid"
    :propPath="propPath"
    :formRef="formRef"
    v-if="!$props.readOnly"
  >
    <template v-slot:default=" { error, deleteServerError }">
      <v-select
          class="b-select--input"
          :class="{ 'b-select--input--has-label': $props.label }"
          v-bind="$props"
          v-on="$listeners"
          :error-messages="error"
          outlined
          dense
          hide-details="auto"
          @keyup="deleteServerError"
          @input="deleteServerError"
      />
    </template>
  </ValidationField>
  <b-read-only-text-field
    v-else
    :label="$props.label"
    :value="currentSelectionText"
    :inlineReadOnly="inlineReadOnly"
  />
</template>

<script>
import _ from 'lodash';
import { VSelect } from 'vuetify/lib';
import ValidationField from "@/components/base_components/ValidationField";

export default {
  components: {ValidationField},
  props: {
    readOnly: { type: Boolean, default: false },
    inlineReadOnly: { type: Boolean, default: false },
    uuid: String,
    propPath: String,
    formRef: String,
    ...VSelect.options.props
  },
  computed: {
    currentSelectionText() {
      var itemValue = this.itemValue || 'value';
      var itemText = this.itemText || 'text';
      var currentValue = this.returnObject
        ? _.get(this.value, itemValue)
        : this.value;
      var currentSelection = this.items.find(
        i => _.get(i, itemValue) == currentValue
      );
      return _.get(currentSelection, itemText);
    }
  }
};
</script>
<style lang="scss">
.b-select--input--has-label {
  & > .v-input__control {
    padding-top: 4px;
  }
}
</style>
